module.exports = __webpack_public_path__ + "img/default2.c06c0677.png";